// extracted by mini-css-extract-plugin
module.exports = {"storieswrap":"fv3Ya","wrap":"f4NLy","line_clamp_2":"ElgGV","astrology_landing":"VyUKo"};